import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrash, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import Header from '../components/header';
import BaseURL from '../assets/contants/BaseURL';
import axios from 'axios';

const MachineGroups = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [machinesgroups, setMachinesgroups] = useState([]);
  const [originalMachinesgroups, setOriginalMachinesgroups] = useState([]);
  const [machines, setMachines] = useState([]);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupName, setGroupName] = useState('');
  const [selectedMachines, setSelectedMachines] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchMachine, setSearchMachine] = useState('');
  const [searchEditMachine, setSearchEditMachine] = useState('');
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const modalRef = useRef();
  const editModalRef = useRef();
  const deleteModalRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (isModalOpen) {
      setGroupName('');
      setSearchMachine('');
      setSelectedMachines([]);
    }
  }, [isModalOpen]);


  const fetchMachinesgroups = async () => {
    try {
      const response = await axios.get(`${BaseURL}meters/machinegroup/`);
      setMachinesgroups(response.data);
      setOriginalMachinesgroups(response.data);
      setTotalPages(Math.ceil(response.data.length / itemsPerPage));
    } catch (error) {
      console.error('Error fetching machine data:', error);
    }
  };

  const fetchMachines = async () => {
    try {
      const response = await axios.get(`${BaseURL}meters/machine/`);
      const machineData = response.data.map(machine => ({
        machine_id: machine.machine_id,
        id: machine.id,
      }));
      setMachines(machineData);
    } catch (error) {
      console.error('Error fetching machine data:', error);
    }
  };

  const handleAddMachine = async () => {
    const newGroup = {
      group_name: groupName,
      machine_list: selectedMachines,
    };


    try {
      const response = await axios.post(`${BaseURL}meters/machinegroup/`, newGroup);
      if (response.status === 201) {
        setModalOpen(false);
        setGroupName('');
        setSelectedMachines([]);
        fetchMachinesgroups();
        setSuccessMessage('Machine group added successfully!'); // Set success message
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        console.error('Error adding machine group:', response);
      }
    } catch (error) {
      console.error('Error adding machine group:', error);
    }
  };

  const handleEditMachine = async () => {
    try {
      const updatedGroup = {
        group_name: groupName,
        machine_list: selectedMachines,
      };
      const response = await axios.put(`${BaseURL}meters/machinegroup/${selectedGroup}/`, updatedGroup);
      if (response.status === 200) {
        setEditModalOpen(false);
        setGroupName('');
        setSelectedMachines([]);
        fetchMachinesgroups();
        setSuccessMessage('Machine group updated successfully!'); // Set success message
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        console.error('Error updating machine group:', response);
      }
    } catch (error) {
      console.error('Error updating machine group:', error);
    }
  };


  const handleDeleteMachine = async () => {
    try {
      if (selectedGroupIds.length === 0) {
        setDeleteModalOpen(true);
        return;
      }

      for (const groupId of selectedGroupIds) {
        const response = await axios.delete(`${BaseURL}meters/machinegroup/${groupId}/`);
        if (response.status === 204) {
          fetchMachinesgroups();
          setSuccessMessage('Machine group deleted successfully!'); // Set success message
          setTimeout(() => setSuccessMessage(''), 3000);
        } else {
          console.error('Failed to delete machine group:', response);
        }
      }
    } catch (error) {
      console.error('Error deleting machine group:', error);
    } finally {
      setDeleteModalOpen(false);
    }
  };


  const handleSearch = () => {
    if (searchTerm.trim() === '') {
      setMachinesgroups(originalMachinesgroups);
    } else {
      const results = originalMachinesgroups.filter((group) => {
        const groupNameMatch = group.group_name.toLowerCase().includes(searchTerm.toLowerCase());
        const machineNamesMatch = group.machines.some(machine =>
          machine.machine_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        return groupNameMatch || machineNamesMatch;
      });
      setMachinesgroups(results);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    handleSearch();
  }, [searchTerm]);

  const openEditModal = (groupId) => {
    const group = machinesgroups.find(group => group.group_id === groupId);

    if (group && Array.isArray(group.machines)) {
      setGroupName(group.group_name);
      setSelectedMachines(group.machines.map(machine => machine.id));
      setSelectedGroup(groupId);
      setEditModalOpen(true);
    } else {
      console.error("Group or machines is undefined or not an array:", group);
    }
  };

  useEffect(() => {
    fetchMachinesgroups();
    fetchMachines();
  }, []);

  // const handleMachineSelect = (event) => {
  //   const selectedMachineIds = Array.from(event.target.selectedOptions, option => {
  //     const machine = machines.find(machine => machine.machine_id === option.value);
  //     return machine ? machine.id : null;
  //   }).filter(id => id !== null);

  //   setSelectedMachines(selectedMachineIds);
  // };

  const handleeditMachineSelect = (event) => {
    const selectedMachineIds = Array.from(event.target.selectedOptions, option => option.value);
    setSelectedMachines(selectedMachineIds);
  };

  const handleGroupCheckboxChange = (groupId) => {
    setSelectedGroupIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(groupId)) {
        return prevSelectedIds.filter(id => id !== groupId);
      } else {
        return [...prevSelectedIds, groupId];
      }
    });
  };

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setModalOpen(false);
    }
    if (editModalRef.current && !editModalRef.current.contains(event.target)) {
      setEditModalOpen(false);
    }
    if (deleteModalRef.current && !deleteModalRef.current.contains(event.target)) {
      setDeleteModalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const currentItems = machinesgroups.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handleAddMachineToList = (machine) => {
    if (!selectedMachines.includes(machine.id)) {
      setSelectedMachines((prevSelectedMachines) => [...prevSelectedMachines, machine.id]);
    }
  };

  const handleRemoveMachine = (machineId) => {
    setSelectedMachines((prevSelectedMachines) =>
      prevSelectedMachines.filter((id) => id !== machineId)
    );
  };

  const handlemeterSearchChange = (event) => {
    setSearchMachine(event.target.value);
  };

  const filteredMachines = machines.filter(machine =>
    machine.machine_id.toLowerCase().includes(searchMachine.toLowerCase())
  );

  const handleRemoveEditMachine = (machineId) => {
    setSelectedMachines((prevSelectedMachines) =>
      prevSelectedMachines.filter((id) => id !== machineId)
    );
  };

  const handleAddeditMachine = (machineId) => {
    setSelectedMachines((prevSelectedMachines) => {
      if (!prevSelectedMachines.includes(machineId)) {
        return [...prevSelectedMachines, machineId];
      }
      return prevSelectedMachines;
    });
  };

  const handleeditmeterSearchChange = (event) => {
    setSearchEditMachine(event.target.value);
  };

  const filterededitMachines = machines.filter((machine) =>
    machine.machine_id.toLowerCase().includes(searchEditMachine.toLowerCase())
  );

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <div style={{
        backgroundColor: '#007acc',
        color: 'white',
        alignContent: 'center',
        fontSize: '14px',
        height: '40px'
      }}>
        <Header title="MACHINE GROUPS" />
      </div>

      <div style={{
        border: '1px solid #ccc',
        padding: '10px',
        marginTop: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        margin: '20px auto',
        maxWidth: '1000px',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', width: '30%' }}>
            <input
              type="text"
              placeholder="Search"
              style={{
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                flex: '1',
                marginRight: '10px',
              }}
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <FontAwesomeIcon
              icon={faSearch}
              style={{ color: '#007acc', cursor: 'pointer' }}
            />
          </div>

          <div style={{ marginLeft: 'auto' }}>
            <button
              style={{
                padding: '10px 15px',
                marginRight: '10px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
              onClick={() => {
                if (selectedGroupIds.length > 0) {
                  setDeleteModalOpen(true);
                }
              }}
            >
              <FontAwesomeIcon icon={faTrash} style={{ marginRight: '5px' }} />
              Delete
            </button>

            <button
              style={{
                padding: '10px 15px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                marginRight: '10px',
              }}
              onClick={() => setModalOpen(true)}
            >
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
              Add
            </button>
          </div>
        </div>
      </div>
      <div style={{ textAlign: 'center', margin: '20px 0' }}>
        {successMessage && (
          <div style={{
            padding: '10px',
            borderRadius: '5px',
            backgroundColor: '#4CAF50',
            color: 'white',
            margin: '10px auto',
            width: 'fit-content',
          }}>
            {successMessage}
          </div>
        )}
      </div>

      <div style={{
        marginTop: '20px',
        padding: '10px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        maxWidth: '1000px',
        margin: '20px auto',
        marginBottom: '70px',
      }}>
        <table style={{ width: "100%", textAlign: "left", borderCollapse: "collapse" }}>
          <thead style={{ backgroundColor: "#007acc", color: "white" }}>
            <tr>
              <th style={{ padding: "10px" }}>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedGroupIds(machinesgroups.map(group => group.group_id));
                    } else {
                      setSelectedGroupIds([]);
                    }
                  }}
                  checked={selectedGroupIds.length === machinesgroups.length}
                />
              </th>
              <th style={{ padding: "10px" }}>S.No</th>
              <th style={{ padding: "10px" }}>Group Name</th>
              <th style={{ padding: "10px" }}>Machine Name</th>
              <th style={{ padding: "10px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ padding: "10px", textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            ) : (
              currentItems.map((group, index) => (
                <tr key={group.group_id} style={{
                  backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#ffffff',
                }}>
                  <td style={{ padding: "10px" }}>
                    <input
                      type="checkbox"
                      checked={selectedGroupIds.includes(group.group_id)}
                      onChange={() => handleGroupCheckboxChange(group.group_id)}
                    />
                  </td>
                  <td style={{ padding: "10px" }}>
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  <td style={{ padding: "10px" }}>{group.group_name}</td>
                  <td style={{ padding: "10px" }}>
                    {group.machines.map(machine => machine.machine_name).join(', ')}
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      color: "blue",
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    onClick={() => openEditModal(group.group_id)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              margin: '0 5px',
              padding: '5px 10px',
              background: currentPage === 1 ? '#007acc' : '#007acc',
              color: currentPage === 1 ? '#9e9e9e' : '#ffffff',
              border: 'none',
              borderRadius: '25px',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              boxShadow: currentPage === 1 ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
              fontSize: '12px',
            }}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index + 1}
              onClick={() => handlePageChange(index + 1)}
              style={{
                margin: '0 5px',
                padding: '5px 10px',
                backgroundColor: currentPage === index + 1 ? '#007acc' : '#f2f2f2',
                color: currentPage === index + 1 ? 'white' : 'black',
                border: 'none',
                borderRadius: '25px',
                cursor: 'pointer',
              }}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              margin: '0 5px',
              padding: '5px 10px',
              background: currentPage === totalPages ? '#007acc' : '#007acc',
              color: currentPage === totalPages ? '#9e9e9e' : '#ffffff',
              border: 'none',
              borderRadius: '25px',
              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
              fontSize: '12px',
            }}
          >
            Next
          </button>
        </div>
      </div>
      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            ref={modalRef}
            style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              width: '60%',
              maxWidth: '600px',
              transition: 'all 0.3s ease',
            }}
          >
            <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Add New Machine Group</h4>
            <div style={{ display: 'flex', gap: '30px' }}>
              <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <label style={{ flex: '0 0 150px', marginRight: '10px' }}>Group Name</label>
                  <input
                    type="text"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder="Enter Group Name"
                    style={{
                      flex: '1',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                    }}
                  />
                </div>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '20px',
                  marginBottom: '10px',
                }}>
                  <div style={{ flex: '1' }}>
                    <label
                      htmlFor="meters"
                      style={{
                        marginBottom: '5px',
                        display: 'block',
                        fontWeight: 'bold',
                      }}
                    >
                      Machine List
                    </label>
                    <div
                      style={{
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        marginBottom: '10px',
                        height: '200px',
                        overflowY: 'auto',
                      }}
                    >
                      <input
                        type="text"
                        value={searchMachine}
                        onChange={handlemeterSearchChange}
                        placeholder="Search for a machine"
                        style={{
                          width: '90%',
                          padding: '10px',
                          marginBottom: '10px',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                        }}
                      />
                      {filteredMachines.map((machine, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                          <span style={{ fontSize: '12px' }}>{machine.machine_id}</span>
                          <button
                            style={{
                              padding: '5px',
                              backgroundColor: selectedMachines.includes(machine.id) ? 'gray' : 'green',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: selectedMachines.includes(machine.id) ? 'not-allowed' : 'pointer',
                              fontSize: '10px'
                            }}
                            onClick={() => handleAddMachineToList(machine)}
                            disabled={selectedMachines.includes(machine.id)}
                          >
                            {selectedMachines.includes(machine.id) ? 'Added' : 'Add'}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>


                  <div style={{ flex: '1' }}>
                    <label
                      style={{
                        marginBottom: '5px',
                        display: 'block',
                        fontWeight: 'bold',
                      }}
                    >
                      Added Machines
                    </label>
                    <div
                      style={{
                        width: '95%',
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        marginBottom: '10px',
                        height: '200px',
                        overflowY: 'auto',
                      }}
                    >
                      {selectedMachines.map((machineId, index) => {
                        const selectedMachine = machines.find(machine => machine.id === machineId);
                        return selectedMachine ? (
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginBottom: '5px',
                              backgroundColor: '#f9f9f9',
                              padding: '5px',
                              borderRadius: '4px',
                            }}
                          >
                            <span style={{ fontSize: '12px' }}>{selectedMachine.machine_id}</span>
                            <button
                              style={{
                                padding: '5px',
                                backgroundColor: '#f44336',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '10px',
                              }}
                              onClick={() => handleRemoveMachine(machineId)}
                            >
                              Remove
                            </button>
                          </div>
                        ) : null;
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleAddMachine}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                Add Machine Group
              </button>
            </div>
          </div>
        </div>
      )}
      {isEditModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            ref={editModalRef}
            style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              width: '60%',
              maxWidth: '600px',
              transition: 'all 0.3s ease',
            }}
          >
            <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Edit Machine Group</h4>
            <div style={{ display: 'flex', gap: '30px' }}>
              <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <label style={{ flex: '0 0 150px', marginRight: '10px' }}>Group Name</label>
                  <input
                    type="text"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder="Enter Group Name"
                    style={{
                      flex: '1',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                    }}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '20px',
                    marginBottom: '10px',
                  }}
                >
                  <div style={{ flex: '1' }}>
                    <label
                      htmlFor="meters"
                      style={{
                        marginBottom: '5px',
                        display: 'block',
                        fontWeight: 'bold',
                      }}
                    >
                      Machine List
                    </label>
                    <div style={{
                      width: '95%',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      marginBottom: '10px',
                      height: '200px',
                      overflowY: 'auto',
                    }}>
                      <input
                        type="text"
                        value={searchEditMachine}
                        onChange={handleeditmeterSearchChange}
                        placeholder="Search for a machine"
                        style={{
                          width: '90%',
                          padding: '10px',
                          marginBottom: '10px',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                        }}
                      />
                      {filterededitMachines.map((machine, index) => (
                        <div key={index} style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '5px',
                          backgroundColor: '#f9f9f9',
                          padding: '5px',
                          borderRadius: '4px',
                        }}>
                          <span style={{ fontSize: '12px' }}>{machine.machine_id}</span>
                          <button
                            onClick={() => handleAddeditMachine(machine.id)}
                            style={{
                              padding: '5px',
                              backgroundColor: selectedMachines.includes(machine.id) ? 'gray' : 'green',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: selectedMachines.includes(machine.id) ? 'not-allowed' : 'pointer',
                              fontSize: '10px',
                            }}
                            disabled={selectedMachines.includes(machine.id)}
                          >
                            {selectedMachines.includes(machine.id) ? 'Added' : 'Add'}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div style={{ flex: '1' }}>
                    <label
                      style={{
                        marginBottom: '5px',
                        display: 'block',
                        fontWeight: 'bold',
                      }}
                    >
                      Added Machines
                    </label>
                    <div
                      style={{
                        width: '95%',
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        marginBottom: '10px',
                        height: '200px',
                        overflowY: 'auto',
                      }}
                    >
                      {selectedMachines.map((machineId, index) => {
                        const machine = machines.find((m) => m.id === machineId);

                        return (
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginBottom: '5px',
                              backgroundColor: '#f9f9f9',
                              padding: '5px',
                              borderRadius: '4px',
                            }}
                          >
                            <span style={{ fontSize: '12px' }}>
                              {machine ? machine.machine_id : 'Unknown Machine'}
                            </span>
                            <button
                              onClick={() => handleRemoveEditMachine(machineId)}
                              style={{
                                padding: '5px',
                                backgroundColor: '#f44336',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '10px',
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
              <button
                onClick={() => setEditModalOpen(false)}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleEditMachine}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            ref={deleteModalRef}
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              width: "400px",
              textAlign: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete the selected machinesgroup?</p>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  style={{
                    padding: "10px 15px",
                    color: "white",
                    backgroundColor: "#4CAF50",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  onClick={handleDeleteMachine}
                >
                  Yes, Delete
                </button>
                <button
                  style={{
                    padding: "10px 15px",
                    color: "white",
                    backgroundColor: "#f44336",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  onClick={() => setDeleteModalOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineGroups;
